import _ from 'lodash';
import moment from 'moment';

export default function formatDate(date, useLocalTime, format) {
	return date !== null && date !== undefined && date !== ''
		? useLocalTime
			? convertToLocalFromUTC(date, format)
			: moment(date).format(format)
		: '-';
}

function convertToLocalFromUTC(date, format = null) {
	if (format === null) {
		return moment
			.utc(date)
			.toDate()
			.toISOString();
	}
	return moment(
		moment
			.utc(date)
			.toDate()
			.toISOString()
	).format(format);
}
